import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import DashedBorder from "@default/general-components/dashed-border";

/**
 * Wraps a form control (input, select, textarea) with an SVG dashed border.
 * Form controls can't have children, so the border is rendered as a sibling
 * inside this relatively positioned wrapper.
 */
const DashedField = ({ children, className }) => (
  <div className={classNames("dashed-field", className)}>
    <DashedBorder pill={false} />
    {children}
  </div>
);

DashedField.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default DashedField;
